import { render, staticRenderFns } from "./cl-tags.vue?vue&type=template&id=552373df&scoped=true&"
import script from "./cl-tags.vue?vue&type=script&lang=ts&"
export * from "./cl-tags.vue?vue&type=script&lang=ts&"
import style0 from "./cl-tags.vue?vue&type=style&index=0&id=552373df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552373df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
